import React from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { PasswordField } from './PasswordField';
import { NewProfile, SECURITY_TYPES, isOpenSecurity } from './wifiSetupModel';

type ManualNetworkFormProps = {
  newProfile: NewProfile;
  onChange: (profile: NewProfile) => void;
  showPassword: boolean;
  onToggleShowPassword: () => void;
  onAdd: () => void;
};

export const ManualNetworkForm: React.FC<ManualNetworkFormProps> = ({
  newProfile,
  onChange,
  showPassword,
  onToggleShowPassword,
  onAdd,
}) => {
  const openSecurity = isOpenSecurity(newProfile.securityType);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="SSID"
          variant="outlined"
          value={newProfile.ssid}
          onChange={(e) => onChange({ ...newProfile, ssid: e.target.value })}
          placeholder="Enter network name"
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Security Type</InputLabel>
          <Select
            value={newProfile.securityType}
            onChange={(e) => {
              const nextSecurityType = e.target.value as string;
              onChange({
                ...newProfile,
                securityType: nextSecurityType,
                ...(nextSecurityType === 'OPEN' ? { password: '' } : {}),
              });
            }}
            label="Security Type"
          >
            {SECURITY_TYPES.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <PasswordField
          value={newProfile.password}
          onChange={(password) => onChange({ ...newProfile, password })}
          showPassword={showPassword}
          onToggleShowPassword={onToggleShowPassword}
          disabled={openSecurity}
          helperText={openSecurity ? 'Not required for Open networks' : undefined}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={newProfile.hiddenSsid}
              onChange={(e) => onChange({ ...newProfile, hiddenSsid: e.target.checked })}
              color="primary"
            />
          }
          label="Hidden SSID"
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          color="primary"
          onClick={onAdd}
          disabled={!newProfile.ssid.trim()}
          startIcon={<Add />}
        >
          Add network
        </Button>
      </Grid>
    </Grid>
  );
};
